import { render, staticRenderFns } from "./CapitalGoodsInvoiceList.vue?vue&type=template&id=5b5c5a1d&scoped=true&"
import script from "./CapitalGoodsInvoiceList.vue?vue&type=script&lang=js&"
export * from "./CapitalGoodsInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./CapitalGoodsInvoiceList.vue?vue&type=style&index=0&id=5b5c5a1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c5a1d",
  null
  
)

export default component.exports